import React from 'react';
import PropTypes from 'prop-types';
import WithAutoHeight from '../../../hoc/WithAutoHeight';
import AddScrollHeight from '../../../components/AddScrollHeight';
import ReserveLink from '../../../components/ReserveLink';
import ServicesComponent from '../../../services/components/Services';

const Services = props => (
  <AddScrollHeight>
    <div className="c-second-layer">
      <div className="o-wrapper o-wrapper--page u-pt">
        <ServicesComponent {...props} nested />
        { props.nextLink && <ReserveLink to={props.nextLink} /> }
      </div>
    </div>
  </AddScrollHeight>
);
Services.propTypes = {
  nextLink: PropTypes.string,
};
Services.defaultProps = {
  nextLink: '',
};

export default WithAutoHeight(Services);




// WEBPACK FOOTER //
// ./src/app/dynamicBooking/time/components/Services.jsx